import React from 'react';
import LayerRow from './LayerRow';

/**
 * Layer table component with single header and separate copy column
 * @param {Object} props - Component props
 * @param {Object} props.groupedLayers - Layers grouped by runtime
 * @param {function} props.onCopy - Function to handle copy action
 * @returns {JSX.Element} Single table with all layers
 */
function LayerTable({ groupedLayers, onCopy }) {
  const runtimes = Object.keys(groupedLayers).sort();
  const allLayers = runtimes.reduce((acc, runtime) => {
    return acc.concat(groupedLayers[runtime]);
  }, []);

  return (
    <div className="layers-table-container">
      <table className="layer-table-unified">
        <thead>
          <tr>
            <th>Lambda Runtime</th>
            <th>Architecture</th>
            <th>Extension Version</th>
            <th>New Relic Agent VERSION</th>
            <th className="arn-column">Layer ARN</th>
            <th className="copy-column">Copy</th>
          </tr>
        </thead>
        <tbody>
          {allLayers.map(layer => (
            <LayerRow key={layer.id} layer={layer} onCopy={onCopy} />
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default LayerTable;
